import React from 'react'
import './styles.scss'

const URLPreview = ({ metadata, isLoading, onClose, className = '', showCloseButton = false, isInInputArea = false }) => {
  if (isLoading) {
    return (
      <div className={`url-preview url-preview-loading ${className}`}>
        <div className={`url-preview-skeleton ${isInInputArea ? 'input-preview' : ''}`}>
          <div className="url-preview-skeleton-image"></div>
          <div className="url-preview-skeleton-content">
            <div className="url-preview-skeleton-line url-preview-skeleton-title"></div>
            <div className="url-preview-skeleton-line url-preview-skeleton-description"></div>
            <div className="url-preview-skeleton-line url-preview-skeleton-url"></div>
            <div className="url-preview-skeleton-line url-preview-skeleton-url"></div>
          </div>
        </div>
      </div>
    )
  }

  if (!metadata) {
    return null
  }

  const { title, description, image, url, siteName } = metadata

  return (
    <div className={`url-preview ${className}`}>
      {showCloseButton && onClose && (
        <button className="url-preview-close" onClick={onClose} aria-label="Close preview">
          <i className="pi pi-times" />
        </button>
      )}
      <div className={`url-preview-content ${isInInputArea ? 'input-preview' : ''}`}>
        {image && (
          <div className="url-preview-image-container">
            <img
              src={image}
              alt={title || 'Preview'}
              className="url-preview-image"
              onError={(e) => {
                e.target.style.display = 'none'
              }}
            />
          </div>
        )}
        <div className={`url-preview-text ${isInInputArea ? 'input-preview' : ''}`}>
          {siteName && <div className="url-preview-site-name">{siteName}</div>}
          {title && <div className="url-preview-title">{title}</div>}
          {description && <div className="url-preview-description">{description}</div>}
          {url && (
            <div className="url-preview-url">
              <a href={url} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
                {url}
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default URLPreview
